/** Compact "1h 23m" / "5m 12s" / "0s" duration from a number of seconds. */
export function fmtDuration(sec: number): string {
  if (sec <= 0) return '0s';
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = Math.floor(sec % 60);
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

/** ElevenLabs credits (not USD): "907 cr." */
export function fmtCost(n: number): string {
  return `${Math.round(n)} cr.`;
}
